export default {
    unauthenticated: 401,
    mustChangePassword: 209,
    disableStatus: 400,
    unauthorized: 403,
};
